const ChoosingCareerChallenge1HintsText =
    ["Try to match the job skills that are listed at the top of each column " +
        "with the abilities that are described for each person.",
     "Since Stan does not like paperwork, he would likely not enjoy a job as a Police Officer.",
     "Sam's skillset sounds like a good fit for a Truck Driver.",
     "Since Pam prefers to work alone, she would probably would not enjoy working as a Chef."]
 
export default ChoosingCareerChallenge1HintsText;